export const saveLocalData = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
};

export const fetchLocalData = (key) => {
  const tokenString = localStorage.getItem(key);
  if (tokenString) {
    const userData = JSON.parse(tokenString);
    return userData;
  }
};

export const removeLocalData = (key) => {
  localStorage.removeItem(key);
};
